export const addBreadcrumbType = '[global] add breadcrumb';
export const setHeaderNavigationType = '[global] set header navigation';
export const setFooterNavigationType = '[global] set footer navigation';
export const setPasswordType = '[global] set password';
export const setPPKType = '[global] set PPK';
export const noOperation = '[global] noop'; // cases where guards in effects create no action needed
